import { Link as RouteLink } from "react-router-dom";
import { Button } from "src/components/ui/button";

const Error404 = () => {
	return (
		<div className="fixed top-0 left-0 z-[1000] w-screen h-screen bg-white flex flex-col items-center justify-center">
			<div className="mb-8">
				<img src="/mee-logo.svg" alt="Mee" className="h-10" />
			</div>

			<h1 className="font-heading text-5xl font-semibold text-foreground">
				404
			</h1>

			<p className="text-lg font-medium text-zinc-800 mt-4 mb-2">
				Page not found
			</p>

			<p className="text-base text-zinc-500 mb-10">
				This page has either been moved or deleted.
			</p>

			<Button asChild>
				<RouteLink to="/">Go to Mee Admin</RouteLink>
			</Button>
		</div>
	);
};

export default Error404;
